
import login from './en-US/login';

const local = {
    ...login,
}

export default local;